import { render } from "./ScreeningsView.vue?vue&type=template&id=e7375088"
const script = {}

import "./ScreeningsView.vue?vue&type=style&index=0&id=e7375088&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__